import React from 'react';
import theme from './HeaderNotificationsButton.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/pro-light-svg-icons';
import { classnames } from '@/utils/html';
import { NotificationBadge } from '@ygtechnologies/bygr-frontend-component-library';

interface NotificationIconProps {
    active: boolean;
    sizeInPx: number;
    unreadNotificationCount: number;
}

const NotificationIcon: React.FC<NotificationIconProps> = ({ active, sizeInPx, unreadNotificationCount }) => {
    return (
        <div
            style={{ width: sizeInPx, height: sizeInPx }}
            className={classnames(theme.icon, { [theme.active]: active })}>
            <FontAwesomeIcon icon={faBell} />
            <NotificationBadge value={unreadNotificationCount} className={theme.notificationsBadge} />
        </div>
    );
};

export default NotificationIcon;
